import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74b6a3b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__block" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "footer__top" }, " Digitalized by DIANA™ — Dental Index Analysis Application "),
  /*#__PURE__*/_createElementVNode("p", { class: "footer__bottom" }, [
    /*#__PURE__*/_createTextVNode(" Результаты расчета не являются диагнозом или медицинской "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" рекомендацией и не заменяют консультации с врачом. ")
  ])
], -1))
const _hoisted_3 = { class: "footer__logo" }

import { defineComponent } from 'vue'
import IconTemplate from '@/apps/components/IconTemplate.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(IconTemplate, {
        height: "19",
        name: "logo",
        width: "77"
      })
    ])
  ]))
}
}

})